A short phrase describing the position as it would be listed on a business card or in a company directory.

This field has a maximum length of 80 characters.
